export const DELIVERY_EMAIL_MAX_LENGTH = 254;
const DELIVERY_EMAIL_PATTERN = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9-]*\.)+[A-Za-z]{2,}$/;
export function normalizeDeliveryEmail(value) {
    return value.trim().replace(/[A-Z]/g, (character) => character.toLowerCase());
}
export function isDeliveryEmail(value) {
    const normalized = normalizeDeliveryEmail(value);
    return normalized.length <= DELIVERY_EMAIL_MAX_LENGTH && DELIVERY_EMAIL_PATTERN.test(normalized);
}
//# sourceMappingURL=email-address.js.map